var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartContainer",style:(_vm.style),attrs:{"id":_vm.chartId}},[_vm._v("Echarts")])
}
var staticRenderFns = []

export { render, staticRenderFns }